import React, { useState, useEffect } from "react";
import { Col, Row, Container } from "react-bootstrap";
import ReactPlayer from "react-player";
import HomeSvg from "../../assets/images/Home-Icon.svg";
import DownloadSvg from "../../assets/images/download-svgrepo-com.svg";
import { useScreenSize, useCustomScreen } from "../Utils";

export default function ProcessSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const devicePixelRatio = window.devicePixelRatio;
  return (
    <section
      className="p-0  pb-sm-5"
      // style={{ height: "auto" }}
      style={{
        height: isSmallScreen ? "auto" : isLargeScreen ? "auto" : "100vh",
        padding: "1em",
      }}
    >
      <div
        style={{
          backgroundColor: " #BAE5EC",
          width: "100%",
          height: isSmallScreen
            ? "auto"
            : isIpadProPortrait
            ? "50vh"
            : isLargeScreen
            ? "auto"
            : isXlScreen
            ? "55dvh"
            : isXlScreen && devicePixelRatio >= 1.5
            ? "50dvh"
            : isXxlScreen
            ? "50vh"
            : "50dvh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="p-4"
      >
        <div>
          <header>
            <h1
              className="text-center"
              style={{
                fontWeight: "bold",
                fontSize: is4kScreen
                  ? "5.3rem"
                  : isXxlScreen
                  ? "2.8rem"
                  : isXlScreen
                  ? "2.7rem"
                  : isIpadProPortrait
                  ? "3rem"
                  : isLargeScreen
                  ? "2.4rem"
                  : isMediumScreen
                  ? "2.4rem"
                  : "2rem",

                paddingTop: isXlScreen
                  ? "1rem"
                  : isXxlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              }}
            >
              From address to measurements
            </h1>
            <p
              className="text-center"
              style={{
                fontSize: is4kScreen
                  ? "2.8rem"
                  : isXxlScreen
                  ? "1.8rem"
                  : isXlScreen
                  ? "1.3rem"
                  : isIpadProPortrait
                  ? "1.9rem"
                  : isLargeScreen
                  ? "1.3rem"
                  : isMediumScreen
                  ? "1.3rem"
                  : "",
              }}
            >
              In 1 Business Day
            </p>
          </header>
        </div>
        <Container
          fluid
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Row style={{ height: "100%" }}>
            <Col xs={12} md={4} xxl={4} className="mb-3">
              <div
                style={{
                  padding: "1.5rem",
                  textAlign: "center",
                  backgroundColor: "#99D2DB",
                  borderRadius: "5px",
                  height: is4kScreen
                    ? "26vh"
                    : isIpadProPortrait
                    ? "30vh"
                    : isLargeScreen
                    ? "40vh"
                    : isXxlScreen && devicePixelRatio === 1.25
                    ? "28vh"
                    : isXxlScreen
                    ? "25vh"
                    : isXlScreen
                    ? "30vh"
                    : "31vh",
                  minHeight: is4kScreen
                    ? "26vh"
                    : isIpadProPortrait
                    ? "30vh"
                    : isLargeScreen
                    ? "40vh"
                    : isXxlScreen && devicePixelRatio === 1.25
                    ? "28vh"
                    : isXxlScreen
                    ? "25vh"
                    : isXlScreen
                    ? "30vh"
                    : "31vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: is4kScreen ? "30vw" : isLargeScreen ? "25vw" : "",
                  maxWidth: is4kScreen ? "30vw" : isLargeScreen ? "30vw" : "",
                }}
              >
                <div className="mt-3 icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={`${
                      is4kScreen
                        ? "80"
                        : isXxlScreen
                        ? "40"
                        : isXlScreen
                        ? "35"
                        : isIpadProPortrait
                        ? "60"
                        : isLargeScreen
                        ? "35"
                        : "35"
                    }`}
                    height={`${
                      is4kScreen
                        ? "80"
                        : isXxlScreen
                        ? "40 "
                        : isXlScreen
                        ? "35"
                        : isIpadProPortrait
                        ? "60"
                        : isLargeScreen
                        ? "35"
                        : "35"
                    }`}
                    fill="currentColor"
                    className="bi bi-geo-alt"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                  </svg>
                </div>
                <div className="mt-1">
                  <h5
                    style={{
                      fontWeight: "bold",
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.7rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.2rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "",
                    }}
                  >
                    Step 1
                  </h5>
                  <h4
                    style={{
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.5rem"
                        : isXlScreen
                        ? "1.2rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "18px",
                      color: "#000",
                    }}
                  >
                    Enter address
                  </h4>
                  <p
                    style={{
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.2rem"
                        : isXxlScreen
                        ? "1.2rem"
                        : isXlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.1rem"
                        : "14px",
                    }}
                  >
                    Sign up for an account and submit a project location.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <div
                style={{
                  padding: "1.5rem",
                  textAlign: "center",
                  backgroundColor: "#99D2DB",
                  borderRadius: "5px",
                  height: is4kScreen
                    ? "26vh"
                    : isIpadProPortrait
                    ? "30vh"
                    : isLargeScreen
                    ? "40vh"
                    : isXxlScreen && devicePixelRatio === 1.25
                    ? "28vh"
                    : isXxlScreen
                    ? "25vh"
                    : isXlScreen
                    ? "30vh"
                    : "31vh",
                  minHeight: is4kScreen
                    ? "25vh"
                    : isIpadProPortrait
                    ? "30vh"
                    : isLargeScreen
                    ? "40vh"
                    : isXxlScreen && devicePixelRatio === 1.25
                    ? "28vh"
                    : isXxlScreen
                    ? "25vh"
                    : isXlScreen
                    ? "30vh"
                    : "31vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: is4kScreen ? "30vw" : isLargeScreen ? "30vw" : "",
                  maxWidth: is4kScreen ? "30vw" : isLargeScreen ? "30vw" : "",
                }}
              >
                <div className="mt-1 icon">
                  <img
                    src={HomeSvg}
                    style={{
                      height: is4kScreen
                        ? "7rem"
                        : isXxlScreen
                        ? "3.5rem"
                        : isXlScreen
                        ? "3rem"
                        : isIpadProPortrait
                        ? "6rem"
                        : isLargeScreen
                        ? "4rem"
                        : "50px",
                      width: is4kScreen
                        ? "7rem"
                        : isXxlScreen
                        ? "3.5rem"
                        : isXlScreen
                        ? "3rem"
                        : isIpadProPortrait
                        ? "6rem"
                        : isLargeScreen
                        ? "4rem"
                        : "50px",
                    }}
                  />
                </div>

                <div className="mt-1">
                  <h5
                    style={{
                      fontWeight: "bold",
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.7rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.2rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "",
                    }}
                  >
                    Step 2
                  </h5>
                  <h4
                    style={{
                      fontSize: "18px",
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.5rem"
                        : isXlScreen
                        ? "1.2rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "18px",
                    }}
                  >
                    We'll measure the roof
                  </h4>
                  <p
                    style={{
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.2rem"
                        : isXxlScreen
                        ? "1.2rem"
                        : isXlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.1rem"
                        : "14px",
                      paddingBottom: is4kScreen ? "1rem" : "",
                    }}
                  >
                    Our technicians will leverage the best imagery to get within
                    3-5% accuracy.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-3">
              <div
                style={{
                  padding: "1.5rem",
                  textAlign: "center",
                  backgroundColor: "#99D2DB",
                  borderRadius: "5px",
                  height: is4kScreen
                    ? "26vh"
                    : isIpadProPortrait
                    ? "30vh"
                    : isLargeScreen
                    ? "40vh"
                    : isXxlScreen && devicePixelRatio === 1.25
                    ? "28vh"
                    : isXxlScreen
                    ? "25vh"
                    : isXlScreen
                    ? "30vh"
                    : "31vh",
                  minHeight: is4kScreen
                    ? "25vh"
                    : isIpadProPortrait
                    ? "30vh"
                    : isLargeScreen
                    ? "40vh"
                    : isXxlScreen && devicePixelRatio === 1.25
                    ? "28vh"
                    : isXxlScreen
                    ? "25vh"
                    : isXlScreen
                    ? "30vh"
                    : "31vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minWidth: is4kScreen ? "30vw" : isLargeScreen ? "30vw" : "",
                  maxWidth: is4kScreen ? "30vw" : isLargeScreen ? "30vw" : "",
                }}
              >
                <div className="mt-2 icon">
                  <img
                    src={DownloadSvg}
                    style={{
                      height: is4kScreen
                        ? "7rem"
                        : isXxlScreen
                        ? "3.5rem"
                        : isXlScreen
                        ? "3rem"
                        : isLargeScreen
                        ? "4rem"
                        : "50px",
                      width: is4kScreen
                        ? "7rem"
                        : isXxlScreen
                        ? "3.5rem"
                        : isXlScreen
                        ? "3rem"
                        : isLargeScreen
                        ? "4rem"
                        : "50px",
                    }}
                  />
                </div>
                <div className="mt-1">
                  <h5
                    style={{
                      fontWeight: "bold",
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.7rem"
                        : isXxlScreen
                        ? "1.4rem"
                        : isXlScreen
                        ? "1.2rem"
                        : isIpadProPortrait
                        ? "1.8rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "",
                    }}
                  >
                    Step 3
                  </h5>
                  <h4
                    style={{
                      fontSize: "18px",
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.6rem"
                        : isXxlScreen
                        ? "1.5rem"
                        : isXlScreen
                        ? "1.2rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.2rem"
                        : "18px",
                    }}
                  >
                    Download your report
                  </h4>
                  <p
                    style={{
                      color: "#000",
                      fontSize: is4kScreen
                        ? "2.2rem"
                        : isXxlScreen
                        ? "1.2rem"
                        : isXlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? "1.1rem"
                        : isMediumScreen
                        ? "1.1rem"
                        : "14px",
                      paddingBottom: is4kScreen ? "1rem" : "",
                    }}
                  >
                    We'll send you a report via email with everything you need.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div
        className="d-flex flex-row justify-content-center align-items-center "
        style={{ height: "45dvh", width: "100%", padding: "20px" }}
      >
        <Container fluid className=" h-100">
          <Row style={{ height: "100%" }}>
            <Col
              xs={12}
              lg={6}
              className="mb-3 d-flex flex-column justify-content-center align-items-center"
            >
              <header>
                <h1
                  className="text-center"
                  style={{
                    fontSize: is4kScreen
                      ? "6rem"
                      : isXxlScreen
                      ? "2.9rem"
                      : isXlScreen
                      ? "2.9rem"
                      : isIpadProPortrait
                      ? "3rem"
                      : isLargeScreen
                      ? "2.5rem"
                      : "",
                  }}
                >
                  It takes <span style={{ color: "#99D2DB" }}>seconds</span> to
                  signup and order
                </h1>
              </header>
            </Col>
            <Col
              xs={12}
              lg={6}
              className="mb-3 p-3 d-flex justify-content-center align-items-center"
            >
              <ReactPlayer
                url="https://www.youtube.com/watch?v=GO9auh1EK1s"
                controls={true}
                width="100%"
                height="100%"
                style={{ objectFit: "contain" }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
}
